import type { M365ServiceStatus } from '../types/m365';

const M365_HEALTH_OVERVIEW_URL = 'https://smartdataproxy.azurewebsites.net/api/M365HealthOverview';

/**
 * Singleton provider for Microsoft 365 service health status.
 * Caches the result in memory and returns the cached array when non-empty.
 */
export class HealthStatusProvider {
    private static instance: HealthStatusProvider;

    /** Cached service status array; fetched from API only when empty. */
    private cachedStatuses: M365ServiceStatus[] = [];

    private constructor() {}

    static getInstance(): HealthStatusProvider {
        if (!HealthStatusProvider.instance) {
            HealthStatusProvider.instance = new HealthStatusProvider();
        }
        return HealthStatusProvider.instance;
    }

    /**
     * Fetches M365 service health status from the REST endpoint.
     * Returns cached array if it is not empty; otherwise fetches from API and caches.
     */
    async GetM365ServiceStatus(): Promise<M365ServiceStatus[]> {
        if (this.cachedStatuses.length > 0) {
            return this.cachedStatuses;
        }

        const response = await fetch(M365_HEALTH_OVERVIEW_URL);
        if (!response.ok) {
            throw new Error(`M365 Health Overview API error: ${response.status}`);
        }
        const data = await response.json();
        const items = Array.isArray(data) ? data : data != null ? [data] : [];
        this.cachedStatuses = items as M365ServiceStatus[];
        return this.cachedStatuses;
    }
}
